import React from "react";
import styles from "./styles.module.scss";
import { Text } from "@radix-ui/themes";

const ServicesList = ({
  services,
  cols = 7,
  openSubService,
  setOpenSubService,
  SubArrow,
}) => {
  return (
    <div className={styles.subServicesGrid}>
      {services.map((sub, i) => [
        <div
          key={sub.name}
          className={
            styles.subCard +
            (openSubService === i ? " " + styles.subActive : "")
          }
          onClick={() => setOpenSubService(openSubService === i ? null : i)}
          tabIndex={0}
          role="button"
          aria-label={sub.name}
        >
          <img 
            src={sub.image} 
            alt={sub.name} 
            className={styles.subImage}
            onError={(e) => {
              console.error(`Failed to load image for ${sub.name}:`, sub.image, e);
            }}
            onLoad={() => {
              console.log(`Successfully loaded image for ${sub.name}`);
            }}
          />
          <div className={styles.subTitle}>
            <Text className={styles.subTitleText}>{sub.name}</Text>
            {SubArrow && (
              <SubArrow
                open={openSubService === i}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenSubService(openSubService === i ? null : i);
                }}
              />
            )}
          </div>
        </div>,
        ((i + 1) % cols === 0 || i === services.length - 1) &&
          openSubService !== null &&
          openSubService >= i - (i % cols) &&
          openSubService <= i && (
            <div
              key={"subPanelBox"}
              className={styles.subPanelBox}
              style={{ gridColumn: `1 / span ${cols}` }}
            >
              <span className={styles.innerSubName}>
                {services[openSubService].name}
              </span>
              {services[openSubService].description}
            </div>
          ),
      ])}
    </div>
  );
};

export default ServicesList;
